import { z } from "zod";

import { createRequiredMessage, INTEGER_FORMAT_MESSAGE, NON_NEGATIVE_MESSAGE } from "./message";
import { isInteger, isNonNegative, isWithinIntLimit } from "./patterns";

// 年収の保存単位は万円。10億円を含めて許可する。
export const MAX_ANNUAL_INCOME = 100_000;
export const ANNUAL_INCOME_RANGE_MESSAGE = "年収は万円単位で、0〜100,000万円（10億円）以内で入力してください。";

export const getAnnualIncomeError = (error: unknown): string | undefined => {
  const response = (
    error as { response?: { status?: number; data?: { code?: string; message?: unknown } } }
  )?.response;
  if (response?.status !== 422 || response.data?.code !== "INVALID_ANNUAL_INCOME") return undefined;
  const message = response.data.message;
  return typeof message === "string" && message.trim() ? message : ANNUAL_INCOME_RANGE_MESSAGE;
};

export const annualIncomeSchema = z
  .string()
  .min(1, createRequiredMessage("年収"))
  .refine((value) => value.trim() !== "" && isInteger(value), { message: INTEGER_FORMAT_MESSAGE })
  .refine(isNonNegative, { message: NON_NEGATIVE_MESSAGE })
  .refine((value) => isWithinIntLimit(value, MAX_ANNUAL_INCOME), { message: ANNUAL_INCOME_RANGE_MESSAGE });
